import React from "react";
import { motion } from "framer-motion";

const partners = [
  { name: "Paytm", logo: "https://cdn.simpleicons.org/paytm" },
  { name: "Airtel", logo: "https://cdn.simpleicons.org/airtel" },
  { name: "Upstox", logo: "https://www.google.com/s2/favicons?domain=upstox.com&sz=128" },
  { name: "Angel One", logo: "https://www.google.com/s2/favicons?domain=angelone.in&sz=128" },
  { name: "Jainam Broking", logo: "https://www.google.com/s2/favicons?domain=jainam.in&sz=128" },
  { name: "Axis Bank", logo: "https://cdn.simpleicons.org/axisbank" },
  { name: "Amazon Pay", logo: "https://www.google.com/s2/favicons?domain=amazon.in&sz=128" },
  { name: "Zerodha", logo: "https://cdn.simpleicons.org/zerodha" },
  { name: "Groww", logo: "https://www.google.com/s2/favicons?domain=groww.in&sz=128" },
  { name: "ICICI Direct", logo: "https://www.google.com/s2/favicons?domain=www.icicidirect.com&sz=128" },
  { name: "HDFC Securities", logo: "https://www.google.com/s2/favicons?domain=hdfcsec.com&sz=128" },
  { name: "Kotak Securities", logo: "https://www.google.com/s2/favicons?domain=kotakneo.com&sz=128" },
  { name: "Motilal Oswal", logo: "https://www.google.com/s2/favicons?domain=motilaloswal.com&sz=128" },
  { name: "5Paisa", logo: "https://www.google.com/s2/favicons?domain=5paisa.com&sz=128" },
  { name: "Sharekhan", logo: "https://www.google.com/s2/favicons?domain=sharekhan.com&sz=128" },
  { name: "HDFC Bank", logo: "https://cdn.simpleicons.org/hdfcbank" },
  { name: "ICICI Bank", logo: "https://cdn.simpleicons.org/icicibank" },
  { name: "SBI YONO", logo: "https://www.google.com/s2/favicons?domain=onlinesbi.sbi&sz=128" },
  { name: "Kotak Mahindra Bank", logo: "https://www.google.com/s2/favicons?domain=kotak.com&sz=128" },
  { name: "Yes Bank", logo: "https://www.google.com/s2/favicons?domain=yesbank.in&sz=128" },
  { name: "PhonePe", logo: "https://cdn.simpleicons.org/phonepe" },
  { name: "Google Pay", logo: "https://cdn.simpleicons.org/googlepay" },
];

const Partners = () => (
  <section id="partners" className="bg-background py-16">
    <div className="mx-auto max-w-7xl px-4">
      <div className="mb-12 text-center">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary-light">
          Our partners
        </p>
        <h2 className="text-3xl font-extrabold text-primary md:text-4xl">
          Trusted by brands that value performance
        </h2>
      </div>

      <div className="group relative overflow-hidden">
        <div className="animate-scroll flex w-max gap-4 group-hover:[animation-play-state:paused]">
          {[...partners, ...partners].map((partner, index) => (
            <motion.div
              key={`${partner.name}-${index}`}
              className="mx-3 flex-shrink-0 rounded-xl bg-white p-3 shadow-md transition-transform duration-300 hover:scale-105 hover:shadow-lg"
              style={{ width: 160 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.03 }}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="mx-auto mb-1 h-12 w-28 object-contain"
                onError={(event) => {
                  event.currentTarget.style.display = "none";
                }}
              />
              <p className="text-center text-sm font-semibold text-primary">{partner.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Partners;
